import { InjectionToken } from '@angular/core';
import { ToothEditorComponentBase } from '@modules/tooth-editor/base/tooth-editor-component-base';

export const TOOTH_EDITOR_COMPONENT = new InjectionToken<ToothEditorComponentBase>(
	'Tooth editor component injection token. Chooses between V0 and V1 editors'
);
